export const QueryPayoutTime = `
fragment PageGenericFragment on PageGeneric {
  frontendPageComponent {
    targetItem {
      ComponentName: field(name: "ComponentName") {
        value
      }
    }
  }
}

fragment C__PageGenericFragment on C__PageGeneric {
  title: field(name: "PageTitle") {
    value
  }
  purename: field(name: "NamePureText") {
    value
  }
  name: field(name: "Name") {
    value
  }
  description: field(name: "Description") {
    value
  }
  data: children {
    key: name
    template {
      name
    }
    ...PayoutTimeFragment
  }
}

fragment PayoutTimeFragment on PayoutTime {
  key: name
  template: template {
    name
  }
  title: field(name: "PageTitle") {
    value
  }
  NoticeMessage: field(name: "NoticeMessage") {
    value
  }
  NoticeEnabled: field(name: "NoticeEnabled") {
    value
  }
  tournamentInfo {
    targetItems {
      ... on FootballTournamentInfo {
        tournamentName: tournamentName {
          value
        }
        tournamentCode: tournamentCode {
          value
        }
        tournamentIcon: tournamentIcon {
          ... on ImageField {
            src(maxWidth: null)
          }
        }
      }
    }
  }
  TournamentInfoEnabled: field(name: "TournamentInfoEnabled") {
    value
  }
  Remarks: field(name: "Remarks") {
    value
  }
  RemarksEnabled: field(name: "RemarksEnabled") {
    value
  }
}

query SpecialPage($path: String!, $lang: String!) {
  Content: item(path: $path, language: $lang) {
    key: name
    ...PageGenericFragment
    ...C__PageGenericFragment
  }
}
`;
